// Apolo IDE — Context Usage drop-up (Cursor-style), opened from the composer.
// Shows the live conversation footprint against the model's context window: a
// stacked bar + a per-category breakdown (Conversa · Ferramentas · Sistema).
//
// Honest note (rendered): this is the conversation's share of the window, NOT
// the full prompt-assembly split — the base prompt (skills / tool definitions)
// is built at send-time in the agent loop and never reaches the renderer.

import { fmtTokens } from './agents/agentFormat.js';

function pctOf(tokens, denom) {
  if (!denom || denom <= 0) return 0;
  return Math.max(0, Math.min(100, (tokens / denom) * 100));
}

export default function ContextUsagePopover({ usage }) {
  const { used = 0, limit = 0, pct = null, segments = [] } = usage || {};
  // bar is relative to the model window when known, else to the used total.
  const denom = limit > 0 ? limit : used || 1;

  return (
    <div className="rx-ctxu" role="dialog" aria-label="Uso de contexto" data-testid="context-usage-popover">
      <div className="rx-ctxu-head">
        <span className="rx-ctxu-title">Uso de contexto</span>
        {pct != null && <span className="rx-ctxu-pct">{pct}% cheio</span>}
      </div>
      <div className="rx-ctxu-sub">
        ~{fmtTokens(used)}{limit > 0 ? ` / ${fmtTokens(limit)}` : ''} tokens
      </div>

      <div className="rx-ctxu-bar" aria-hidden="true">
        {segments.map((s) => (
          <span key={s.key} style={{ width: `${pctOf(s.tokens, denom)}%`, background: s.color }} />
        ))}
      </div>

      <ul className="rx-ctxu-list">
        {segments.length === 0 ? (
          <li className="rx-ctxu-empty">Conversa vazia — nada no contexto ainda.</li>
        ) : (
          segments.map((s) => (
            <li key={s.key}>
              <span className="rx-ctxu-dot" style={{ background: s.color }} aria-hidden="true" />
              <span className="rx-ctxu-label">{s.label}</span>
              <span className="rx-ctxu-tok">{fmtTokens(s.tokens)}</span>
            </li>
          ))
        )}
      </ul>

      <p className="rx-ctxu-note">
        Footprint da conversa (turnos · ferramentas · sistema). Não inclui o
        prompt base (skills / ferramentas) montado no envio.
      </p>
    </div>
  );
}
